import React from 'react'
import { Badge } from '../components/ui/badge'

export type StatusType = 'active' | 'upcoming' | 'draft' | 'completed' | 'live'

export interface StatusPillProps {
  status: StatusType
  label?: string
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

const classByStatus: Record<StatusType, string> = {
  active: 'bg-status-green-bg text-status-green',
  upcoming: 'bg-status-blue-bg text-status-blue',
  draft: 'bg-sun-20 text-sun',
  completed: 'bg-thunder-grey-20 text-thunder-grey',
  // Live matches "Pill with border and dot" (Tailwind UI Blocks)
  live: 'bg-status-green-bg text-status-green border border-status-green'
}

const StatusPill: React.FC<StatusPillProps> = ({ status, label, className = '', size = 'md' }) => {
  const text = label ?? capitalize(status)
  const prefixDot =
    status === 'live' ? <span className="mr-2 inline-block h-2 w-2 rounded-full bg-status-green" /> : null

  return (
    <Badge variant="ghost" size={size} className={`${classByStatus[status]} text-button-medium ${className}`}>
      {prefixDot}
      {text}
    </Badge>
  )
}

function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export default StatusPill
